const productCustomiser = {
    init() {

        var orderForm = $('#orderForm');

        $(document).on('click', function () {
            $('.custom-select-options').removeClass('active');
        })

        $(document).on('click', '.selected', function (e) {
            e.stopPropagation();
            $(this).parent().find('.custom-select-options').toggleClass('active');
        })


        //change row
        $(document).on('click', '.custom-select [data-product]', function () {
            var $this = $(this);
            var value = $(this).attr('data-colour');
            var id = $(this).attr('data-value');
            var product = $(this).attr('data-product');
            var attr = $(this).attr('data-attr');
            $this.parent().parent().parent().find('.selected .selected-item').text(attr);
            $this.parent().parent().parent().find('.selected .selected-item').attr('data-slug', attr);
            $this.parent().parent().parent().find('.selected').attr('data-colour', value);

            $.ajax({
                url: ajaxparams.ajaxurl, // AJAX handler
                data: {
                    'action': 'change_row', // the parameter for admin-ajax.php
                    'value': value,
                    'data_id': id,
                    'product': product
                },
                type: 'POST',
                beforeSend: function (xhr) {

                },
                success: function (data) {

                    $this.parent().parent().parent().find('.sizes-row').replaceWith(data);
                }
            });
            return false;
        })
        var currentVals = [];

        //Add new row
        var clicks = 1;
        $('.js-add-colours').on('click', function () {
            var $this = $(this);
            var data_id = $(this).attr('data-id');
            var count = clicks - 1
            console.log(count + '/' + clicks);


            $('.product-customiser__row-new').each(function (index, el) {

                var $item = $(el).find('.selected-item').attr('data-slug');
                currentVals.push($item);
            })

            console.log(currentVals);
            $.ajax({
                url: ajaxparams.ajaxurl, // AJAX handler
                data: {
                    'action': 'add_new_row', // the parameter for admin-ajax.php
                    'product': data_id,
                    'count': count,
                    'current': currentVals,
                    'item': clicks
                },
                type: 'POST',
                beforeSend: function (xhr) {

                },
                success: function (data) {
                    if (data.success == false) {
                        $('.product-customiser__rows-new').append('No more products');
                        $this.remove();
                    } else {
                        $('.product-customiser__rows-new').append(data);
                    }


                }
            });


            clicks++;
            if (clicks == count) {
                return;
            }
            return false;
        });

        //Add line items
        var variation_ids = [];
        var totalQty = 0;
        $(document).on('change', '.input-wrapper input', function () {

            var $this = $(this);
            var selected_colour = $this.parent().parent().parent().find('.selected').attr('data-colour');
            var pa_size = $this.attr('data-quantity');
            var variation = $this.attr('data-variation');
            var qty = $this.val();
            var type = $(this).parent().attr('data-type');

            $('.js-add-print').attr('data-qty', qty);

            console.log(selected_colour);
            $('.js-add-print').removeClass('disabled');

            var data;
            if (type == 'size') {
                data = {
                    'action': 'add_variation_to_order', // the parameter for admin-ajax.php
                    'pa_colour': selected_colour,
                    'pa_size': pa_size,
                    'qty': qty,
                    'product_id': $('#customiser').attr('data-id'),
                    'type': type
                }
            } else {
                data = {
                    'action': 'add_variation_to_order', // the parameter for admin-ajax.php
                    'pa_colour': selected_colour,
                    'qty': qty,
                    'product_id': $('#customiser').attr('data-id'),
                    'type': type
                }
            }


            $.ajax({
                url: ajaxparams.ajaxurl, // AJAX handler
                data: data,
                type: 'POST',
                beforeSend: function (xhr) {

                },
                success: function (data) {
                    console.log(data);

                    var variation_id = data.data.variation_id;
                    var qty = data.data.qty;
                    var htmlData = data.data.html;
                    var price = data.data.variation_price;

                    variation_ids.push({
                        'variation_id': variation_id,
                        'qty': qty,
                        'html': htmlData,
                        'price': price
                    });

                    if ('div[data-variation="' + variation_id + '"]') {
                        orderForm.find('div[data-variation="' + variation_id + '"]').remove();
                    }

                    if (qty <= 0) {
                        orderForm.find('div[data-variation="' + variation_id + '"]').remove();
                        htmlData = false;
                    }

                    if (htmlData) {
                        orderForm.append(htmlData);
                    }

                    calculate_totals();
                }
            });
            return false;

        });

        $(document).on('click', '.js-add-to-cart-product', function () {
            var data = $('#orderForm').serializeArray().reduce(function (obj, item) {

                if ($.isNumeric(item.name)) {
                    // Value is an integer
                    obj[item.name] = item.value;
                }

                return obj;
            }, {});
            var total = $('.total-amount').html();

            console.log("OrderForm Serialise ", data);

            let printingJson = [];

            var printing = $('#orderForm').serializeArray().reduce(function (obj, item) {

                if (!$.isNumeric(item.name)) {
                    var dataPrice = $('input[name="' + item.name + '"]').attr('data-price');
                    let inputField = $('input[name="' + item.name + '"]');
                    // Value is an integer
                    obj[item.name] = dataPrice;
                    //change this to return JSON
                    printingJson.push({ 'name': item.name, 'default': inputField.attr('data-default'), 'setup': inputField.attr('data-setup'), 'qty': item.value });
                    return printingJson;
                }

                return obj;
            }, {});

            $.ajax({
                url: ajaxparams.ajaxurl, // AJAX handler
                data: {
                    'action': 'build_order', // the parameter for admin-ajax.php
                    'order': data,
                    'printing': printing,
                    'total': total,
                    'product_id': $('#customiser').attr('data-id')
                },
                type: 'POST',
                beforeSend: function (xhr) {

                },
                success: function (response) {
                    // $(document.body).trigger('added_to_cart');
                    console.log(response);
                    var redirectURL = response.data.redirect_url;
                    //window.location.href = redirectURL;
                    window.location.href = '/cart/';
                }
            });
            return false;
        });

        function calc_markup(val) {

            return (val + ((val * cost_markup) / 100));
        }

        function calculate_totals() {
            // console.log(totalQty);
            var sum = 0;
            var price = 0;
            let itemprice = 0;
            let printSetupPrice = 0;
            let printNominal = 0;
            let printColourQty = 0;
            let stockQty = 0;
            let total_price_noprint = 0;

            $('#orderForm :input').each(function (index, el) {
                var $qty = parseFloat($(el).val());
                // totalQty = totalQty + parseFloat($qty);
                console.log(el);

                sum += Number($(el).val());
                //var $dataPrice = $(el).attr('data-price');
                itemprice = Number($(el).attr('data-price'));
                let $dataSetupPrice = $(el).attr('data-setup');

                if ($(el).attr('data-count')) {
                    stockQty += Number($(el).val());
                    console.log("Stock Qty", stockQty);
                    itemprice = Number($(el).attr('data-price'));
                    total_price_noprint += (itemprice * Number($(el).val()));
                }

                if (!isNaN($dataSetupPrice)) {
                    printSetupPrice += Number($dataSetupPrice) * Number($(el).val());
                    console.log("Print setup price", printSetupPrice);
                    printNominal += (Number($(el).attr('data-default')) * Number($(el).val()));
                    console.log("Print Nominal", stockQty);
                }
            })

            if (sum !== 0) {
                $('.js-add-to-cart-product').removeClass('disabled');
            } else {
                $('.js-add-to-cart-product').addClass('disabled');
            }

            $('.totals').slideDown();

            //$('.total-amount').text(price.toFixed(2));
            //this is actually returning the print options range
            let prints = $('input[data-range]').length;
            console.log(prints);

            if (isNaN(printSetupPrice)) {
                printSetupPrice = 0.00;
            }
            //$('.setup-amount').html((calc_markup(printSetupPrice)).toFixed(2));

            var variation_length = $('#orderForm [data-variation]').length;

            let perItem = itemprice;
            console.log(itemprice);

            if (isNaN(perItem)) {
                perItem = 0.00;
            }
            //$('.per-item').html(calc_markup(perItem).toFixed(2));
            //$('.print-per-item-amount').html(calc_markup(printNominal).toFixed(2));


            let $shippingPrice = $('.shipping-amount').attr('data-ship');
            let total_val = 0;
            //total_val = (total_price_noprint + printSetupPrice+(printNominal*stockQty))+Number($shippingPrice);

            printSetupPrice = printSetupPrice;
            perItem = itemprice;
            printNominal = printNominal;
            total_price_noprint = total_price_noprint;

            total_val = (total_price_noprint + printSetupPrice + (printNominal * stockQty));
            perItem = (total_val / stockQty);

            $('.setup-amount').html(printSetupPrice.toFixed(2));
            $('.per-item').html(perItem.toFixed(2));
            $('.print-per-item-amount').html(printNominal.toFixed(2));
            $('.total-amount').text(total_val.toFixed(2));

        }

        var modal = $("#printModal");

        $(".js-add-print").on("click", function () {
            $('body').addClass('overlayActive');
            /*let get_radio = $( "input:radio" );
            for(let a= 0;a<get_radio.length;a++){
                console.log(get_radio[a]);
                get_radio[a].checked = false;
            }*/
            modal.show();
        });

        $('.modal-header span, .modal-footer .cancel').on('click', function () {
            modal.hide();
            $('body').removeClass('overlayActive');
        })

        $('body').on('click', '.remove-row', function () {
            $(this).parent().remove();
            var name = $(this).attr('data-name');
            $('#orderForm').find('input[name="' + name + '"]').remove();
            calculate_totals();
        })

        // $(document).on("click", function(event) {
        //
        //     if (event.target !== modal && $(event.target).closest(".modal").length === 0) {
        //         modal.hide();
        //     }
        // });



        $('[data-print-add]').on('click', function (e) {
            e.preventDefault();
            var radioButtons = $("input[type='radio']:checked");

            // Get all the values of the checked radio buttons
            var values = [];
            var object = {};
            radioButtons.each(function () {
                var id = $('#customiser').attr('data-id');
                console.log(id);
                //if (id !== 'CLEAR') {
                    var qty = $('.js-add-print').attr('data-qty');
                    object = {
                        'position': $(this).attr('data-position'),
                        'ID': $(this).attr('data-id'),
                        'value': $(this).val(),
                        'image': $(this).parent().attr('data-image'),
                        'width': $(this).attr('data-width'),
                        'height': $(this).attr('data-height'),
                        'colours': $(this).attr('data-colours'),
                        'qty': qty
                    }
                    values.push(object);
                //}
            });

            // Do something with the values
            console.log(values);
            $.ajax({
                url: ajaxparams.ajaxurl,
                type: "POST",
                data: {
                    action: "print_add",
                    product_id: $('#customiser').attr('data-id'),
                    values: values
                },
                success: function (response) {
                    console.log("ADD Print response", response);
                    //get the inputs and clear them out
                    $('input[data-setup]').remove();
                    //then this
                    $('#printRow').html(response.data.html);
                    if (response.data.inputs) {
                        orderForm.append(response.data.inputs);
                    }

                    calculate_totals();
                    modal.hide();
                    $('body').removeClass('overlayActive');
                }
            });
        })

        $('body').on('change', '.colours', function () {
            console.log('changed');
            var pos = $(this).find('option:selected').attr('data-position');
            $('input[name="' + pos + '"]').val($(this).find('option:selected').val());
            calculate_totals();
        })



    }
}

export { productCustomiser }